<!--赖传峰-->
<!--2022/3/31-->
<template>
  <div class="share-not-available">
    <div :style="`background: url(${config.imgSrc}) var(--no-repeat-center)`">
      {{ statusText || config.title }}
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  useI18n,
} from '#imports'
import deleted from '@/assets/images/share/share-deleted.svg'
import expired from '@/assets/images/share/share-expired.svg'
import sensitive from '@/assets/images/share/share-sensitive.svg'
import { ShareStatus } from '@/types/enum'

const { t } = useI18n()

const props = defineProps<{ status: ShareStatus; statusText?: string }>()

const config = computed<{ imgSrc: string, title: string }>(() => {
  if (props.status === ShareStatus.DELETED) {
    return {
      imgSrc: deleted,
      title: t('share-deleted-title'),
    }
  }
  if ([ShareStatus.NOT_FOUND, ShareStatus.PROHIBITED].includes(props.status)) {
    return {
      imgSrc: deleted,
      title: t('share-not-found-title'),
    }
  }
  if ([ShareStatus.SENSITIVE_RESOURCE, ShareStatus.SENSITIVE_WORD].includes(props.status)) {
    return {
      imgSrc: sensitive,
      title: t('share-sensitive-title'),
    }
  }

  return {
    imgSrc: expired,
    title: t('share-expired-title'),
  }
})

</script>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util.less';

.share-not-available {
  display: flex;
  height: 100%;
  background: #fff;

  > div {
    color: var(--color-tertiary-text);
    height: 248px;
    display: flex;
    margin-top: 10%;
    flex: 1;
    justify-content: center;
    align-items: flex-end;
    padding: 0 16px;
  }
}

</style>
